module.exports = {"basicInfo":"Basic Informantion","locator":"Trip Locator","sales_username":"Sales Person","group_or_indiv":"Group or Individual","tripGroup":"Group","tripIndividual":"Individual","ticketed_time":"Ticketing","invoice":"Invoice","note":"Remark"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/airticket/create/information.json
// module id = RXyN
// module chunks = 58